import "./styles/reset.css"
import "./styles/functional.css"
import "./styles/fonts.css"

import "./styles/vars.css"
import "./styles/animations.css"
import "./styles/layout.css"
import "./styles/header.css"
import "./styles/footer.css"
import "./styles/aside.css"
import "./styles/cards.css"
import "./styles/menu.css"
import "./styles/icons.css"
import "./styles/buttons.css"
import "./styles/embeds.css"
import "./styles/forms.css"
import "./styles/prose.css"
import "./styles/elements.css"
import "./styles/lead.css"
import "./styles/cases.css"

import { initFilterForm } from "./components/filter-form.js"
import { initAside, initNav } from "./components/nav.js"
import { onReady } from "./utils.js"

window.htmx = require("htmx.org")

const initScrolledNav = () => {
  let lastScroll = 0
  const handleScroll = () => {
    document.body.classList.toggle(
      "scrolled-up",
      window.scrollY > 16 && window.scrollY <= lastScroll,
    )
    document.body.classList.toggle("scrolled", window.scrollY > 16)
    lastScroll = window.scrollY
  }
  handleScroll()
  window.addEventListener("scroll", handleScroll, { passive: true })
}

window.TOGGLE_TIMING = 200

onReady(() => {
  function setStyles() {
    const mainWidth = document.querySelector("main").offsetWidth
    document.body.style = `--toggle-timing: ${window.TOGGLE_TIMING}ms; --main-width: ${mainWidth}px`
  }
  setStyles()
  window.addEventListener("resize", setStyles)
})

onReady(initScrolledNav)
onReady(initNav)
onReady(initAside)
onReady(initFilterForm, true)
